import { createContext, useContext, useReducer } from "react";

export const FileStore = createContext<IContextProps>(null);

export const CHANGE_TYPE = {
    1:{
        text: "注册",
        color:''
    },
    2:{
        text: "管理员手动",
        color:''
    },
    3:{
        text: "自动晋升",
        color:''
    },
    4:{
        text: "自动降级",
        color:''
    },
    5:{
        text: "回滚降级",
        color:''
    },
}
interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type, payload }

interface IState {
    search: Search;
}
class Search {
    seackerKey: string;
};
const initialArgs = {
    dataList: [],
    search: new Search(),
}

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        case "SetSearch":
            return {
                ...state,
                search: {
                    ...state.search,
                    ...payload
                }
            }
        default:
            return state;
    }
}

export function GradeChangeLogsStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <FileStore.Provider value={v}>{props.children}</FileStore.Provider>
}